import axios from 'axios'

const state = {
    list: [],
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
}

const options = {
    headers: {
        'Accept': 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
    }
};

const actions = {

    getMonthStats(context, payload) {
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/planning_management/month_stats')
            .then((response) => {
                return response
            })
    },

    getIndexCounts(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/planning_management/index_counts', payload, options)
            .then((response) => {
                return response
            })
    },

    getPrevisions(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/planning_management/previsions', payload, options)
            .then((response) => {
                return response
            })
    },

    getOneTimeInterventions(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/planning_management/one_time_interventions', payload, options)
            .then((response) => {
                return response
            })
    },

    deleteOneTimeIntervention(context, payload) {
        return axios.delete(process.env.VUE_APP_API_BASE_URL + '/planning_management/one_time_interventions/' + payload.intervention_id + '/delete', options)
            .then((response) => {
                return response
            })
    },

    getPlannedDay(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/planning_management/get_planned_day', payload, options)
            .then((response) => {
                return response
            })
    },

    getCartTravelTimes(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/planning_management/get_cart_travel_times', payload, options)
            .then((response) => {
                return response
            })
    },

    getNewCart(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/planning_management/get_new_cart', payload, options)
            .then((response) => {
                return response
            })
    },

    storeCart(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/planning_management/store_cart', payload, options)
            .then((response) => {
                return response
            })
    },
}

const getters = {
    list: state => state.list,
};

const products = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default products;
